import AppHeaderAvatarUser from './AppHeaderAvatarUser';
import imgLogo from '@/assets/images/png/logo.png';
import { useUserConnected } from '@/hooks';
import { Link } from 'react-router-dom';
import routes from '@/lib/routes';
import { cn } from '@/lib/utils';

const AppHeader = () => {

	const { userConnected } = useUserConnected();

	if (!userConnected) {
		return <></>;
	}

	return (
		<header className={`w-full border-b`}>
			<nav className={cn(
				'flex flex-row justify-between items-center m-2 ',
				'md:container'
			)}>
				<Link
					to={routes.nav.home}
					className='flex flex-row items-center gap-x-2'>
					<img
						src={imgLogo}
						alt={'Heyama admin logo'}
						className={'w-9'} />
					<h2 className='text-xl font-bold'>
						Admin
					</h2>
				</Link>
				<AppHeaderAvatarUser />
			</nav>
		</header>
	);

};

export default AppHeader;
